import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import Main from './Main'
import firebase from 'firebase/app'
import 'firebase/database'
import base, {auth} from './base'
import SignIn from './SignIn'

class App extends Component {
  constructor() {
    super()

    this.state = {
      fave: "None!",
      number: "Enter Here",
      carrier: "txt.att.net",
      uid: null
    }


  }

  componentDidMount(){
      auth.onAuthStateChanged(
            (user) => {
                 if(user){
                  this.authHandler(user);
                     //We are already signed in
                     base.fetch(`${user.uid}/fave`, {
                      context: this,
                      asArray: false,
                      then(data){
                        var fave = data;
                        if(""+data==="[object Object]"){
                          this.syncFave();
                          this.syncData();
                        }else{
                         this.setState({ fave })
                         }
                        
                      }
                    
                    });
                    base.fetch(`${user.uid}/carrier`, {
                      context: this,
                      asArray: false,
                      then(data){
                        var carrier = data;
                        if(""+data==="[object Object]"){
                          this.syncFave();
                          this.syncData();
                        }else{
                         this.setState({ carrier })
                         }
                        
                      }
                    
                    });
                    base.fetch(`${user.uid}/number`, {
                      context: this,
                      asArray: false,
                      then(data){
                        var number = data;
                        console.log(data)
                        if(""+data==="[object Object]"){
                          this.syncFave();
                          this.syncData();
                        }else{
                         this.setState({ number })
                         }
                        
                      }
                    
                    });
                 }
            }
        )    
   }

  handleChange(ev){
    this.setState({
      fave: ev.target.value
    }, this.syncFave);

  }

  syncFave = () => {
    var immediatelyAvailableReference = base.update(`${this.state.uid}`, {
      data: {fave: this.state.fave},
      then(err){
        if(!err){
          
        }
      }
    });
  }

  syncData = () => {
    var immediatelyAvailableReference = base.update(`${this.state.uid}`, {
      data: {carrier: this.state.carrier, number: this.state.number},
      then(err){
        if(!err){
          
        }
      }
    });
  }

  submit(ev){
    ev.preventDefault();

    var number = ev.target.number.value;
    var carrier  = ev.target.carrier.value;

    this.setState({ number, carrier }, this.syncData);

  }

  signedIn = () => {
    return this.state.uid;
  }

  signOut = () => {
    auth
        .signOut()
        .then(() => {
            this.setState({uid: null })
        })
}

authHandler = (userData) => {
    this.setState(
                {uid: userData.uid}
                 )
    
}

  render(){
    return(
      <div className="App">
        {this.signedIn()
          ?
          <Main fave={this.state.fave} number={this.state.number} carrier={this.state.carrier} handleChange={this.handleChange.bind(this)} signOut={this.signOut.bind(this)} submit = {this.submit.bind(this)}/>
          : <SignIn />
        }
      </div>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js